import { render, staticRenderFns } from "./JustifiedLayout.vue?vue&type=template&id=67f42555&lang=html&"
import script from "./JustifiedLayout.vue?vue&type=script&lang=js&"
export * from "./JustifiedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports